module.exports = __webpack_public_path__ + "img/case3-工业大学.54a9fead.png";